import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { login, getCode, logout, getUserInfo, instrumentType, teacher, campus, business, saleList, orderList, marketList, customerList, teachList, teaching, dashboardIndex, teachingRatio, studentIndex, courseType, studentLevels, customerSource, userHistory, getInstrument, getCampus, getCourse, campusClassroom, student, curriculum, deleteCourse, getCustomer, getNowCustomer, getBaseCourse, courseLevel, material, courseSign, getEditAudition, getClassSign, getCourseSignLists, studentLevel, dashboardStudent, campusDetails, addCampusClassroom, editCampusClassroom, lessStudent, deleteCampusClassroom, editCourse, studentIsCourse, getClueNumber, yearSale, saleDetailList, marketDetailList, customerDetailList, orderDetailList, yearOrder, yearMarket, yearTeachData, yearCustomer, teachCourseList, getFeedbackNumber, deleteFeedback,getReserveStudent } from '@/api/users'
import { getToken, setToken, removeToken, setCookie } from '@/utils/cookies'
import router, { asyncRoutes, resetRouter } from '@/router'
import { PermissionModule } from './permission'
import store from '@/store'

export interface IUserState {
  token: string
  name: string
  avatar: string
  introduction: string
  roles: string[]
  role_content: string[]
  clue_number: number,
  feedback_number: number
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public name = ''
  public avatar = ''
  public introduction = ''
  public roles: string[] = []
  public role_content: string[] = []
  public clue_number = 0
  public feedback_number = 0

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }
  @Mutation
  private SET_CLUE(num: number) {
    this.clue_number = num
  }

  @Mutation
  private SET_FEEDBACK(num: number) {
    this.feedback_number = num
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_INTRODUCTION(introduction: string) {
    this.introduction = introduction
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles
  }

  @Action
  public async Login(userInfo: { username: string, password: string }) {
    let { username, password } = userInfo
    username = username.trim()
    const res: any = await login({ username, password })
    if (res.code === 200) {
      setToken(res.data.accessToken)
      this.SET_TOKEN(res.data.accessToken)
    }
    return res
  }

  @Action
  public ResetToken() {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
  }

  @Action
  public async GetUserInfo() {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!')
    }
    const { data } = await getUserInfo({ /* Your params here */ })
    if (!data) {
      throw Error('Verification failed, please Login again.')
    }
    const { roles, name, avatar, introduction, role_content, is_enabled } = data.user
    // roles must be a non-empty array
    if (data.user.is_enabled === 0) {
      this.ResetToken()
    }
    if (!roles || roles.length <= 0) {
      throw Error('GetUserInfo: roles must be a non-null array!')
    }
    this.SET_ROLES(roles)
    this.SET_NAME(name)
    this.SET_AVATAR(avatar)
    this.SET_INTRODUCTION(introduction)
    await this.GetClueNumber()
    await this.GetFeedbackNumber()
    const rolesList: any = role_content
    for (var i = 0; i < rolesList.length; i++) {
      if (rolesList[i].children) {
        asyncRoutes[i].meta.roles = rolesList[i].roles
        for (var j = 0; j < rolesList[i].children.length; j++) {
          asyncRoutes[i].children[j].meta.roles = rolesList[i].children[j].roles
        }
      } else {
        asyncRoutes[i].children[0].meta.roles = rolesList[i].roles
      }
    }
  }
  @Action
  public async GetClueNumber() {
    const res = await getClueNumber()
    this.SET_CLUE(res.data.count)
    setCookie('clue-count', res.data.count)
  }
  @Action
  public async GetFeedbackNumber() {
    const res = await getFeedbackNumber()
    this.SET_FEEDBACK(res.data.count)
    setCookie('feedback-count', res.data.count)
  }

  @Action
  public async ChangeRoles(role: string) {
    // Dynamically modify permissions
    const token = role + '-token'
    this.SET_TOKEN(token)
    setToken(token)
    await this.GetUserInfo()
    resetRouter()
    // Generate dynamic accessible routes based on roles
    // PermissionModule.GenerateRoutes(this.roles)
    PermissionModule.GenerateRoutes(['admin'])
    // Add generated routes
    router.addRoutes(PermissionModule.dynamicRoutes)
    // Reset visited views and cached views
    // TagsViewModule.delAllViews()
  }

  @Action
  public async LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    await logout()
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
    resetRouter()
  }
  @Action({ rawError: true })
  public async getCode(data) {
    return await getCode(data)
  }

  // 仪表盘相关
  @Action({ rawError: true })
  public async InstrumentType() {
    return await instrumentType()
  }
  @Action({ rawError: true })
  public async getTeacher() {
    return await teacher()
  }
  @Action({ rawError: true })
  public async getSchool() {
    return await campus()
  }
  @Action({ rawError: true })
  public async business({ business_type, data_type, instrument_type, campus_id, teacher_id, start_time, end_time }) {
    return await business(business_type, data_type, instrument_type, campus_id, teacher_id, start_time, end_time)
  }
  @Action({ rawError: true })
  public async teaching({ data_type, instrument_type, campus_id, teacher_id, start_time, end_time }) {
    return await teaching(data_type, instrument_type, campus_id, teacher_id, start_time, end_time)
  }
  @Action({ rawError: true })
  public async dashboardIndex({ data_type, instrument_type, campus_id, teacher_id, start_time, end_time }) {
    return await dashboardIndex(data_type, instrument_type, campus_id, teacher_id, start_time, end_time)
  }
  @Action({ rawError: true })
  public async teachingRatio({ data_type, instrument_type, campus_id, teacher_id, start_time, end_time, is_avg }) {
    return await teachingRatio(data_type, instrument_type, campus_id, teacher_id, start_time, end_time, is_avg)
  }
  @Action({ rawError: true })
  public async studentIndex({ data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages }) {
    return await studentIndex(data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages)
  }
  @Action({ rawError: true })
  public async courseType() {
    return await courseType()
  }
  @Action({ rawError: true })
  public async studentLevels() {
    return await studentLevels()
  }
  @Action({ rawError: true })
  public async customerSource() {
    return await customerSource()
  }
  @Action({ rawError: true })
  public async userHistory() {
    return await userHistory()
  }
  @Action({ rawError: true })
  public async getInstrument({ org_id }) {
    return await getInstrument(org_id)
  }
  @Action({ rawError: true })
  public async getCampus({ types, org_id }) {
    return await getCampus(types, org_id)
  }
  @Action({ rawError: true })
  public async getCourse({ org_id, campusId, teacherEmployeeId, instrumentTypeId, startTime, hidden_data }) {
    return await getCourse(org_id, campusId, teacherEmployeeId, instrumentTypeId, startTime, hidden_data)
  }
  @Action({ rawError: true })
  public async campusClassroom({ org_id, campus_id }) {
    return await campusClassroom(org_id, campus_id)
  }
  @Action({ rawError: true })
  public async student({ org_id, name }) {
    return await student(org_id, name)
  }
  @Action({ rawError: true })
  public async lessStudent({ org_id, name, is_less }) {
    return await lessStudent(org_id, name, is_less)
  }
  @Action({ rawError: true })
  public async studentIsCourse({ org_id, name, is_course }) {
    return await studentIsCourse(org_id, name, is_course)
  }
  @Action({ rawError: true })
  public async curriculum(data) {
    return await curriculum(data)
  }
  @Action({ rawError: true })
  public async deleteCourse(data) {
    return await deleteCourse(data)
  }
  @Action({ rawError: true })
  public async getReserveStudent(data) {
    return await getReserveStudent(data)
  }
  @Action({ rawError: true })
  public async getCustomer({ name, phone, org_id }) {
    return await getCustomer(name, phone, org_id)
  }
  @Action({ rawError: true })
  public async getNowCustomer({ name, customer_id, phone, org_id }) {
    return await getNowCustomer(name, customer_id, phone, org_id)
  }
  @Action({ rawError: true })
  public async getBaseCourse({ org_id, campus_id }) {
    return await getBaseCourse(org_id, campus_id)
  }
  @Action({ rawError: true })
  public async courseLevel({ org_id }) {
    return await courseLevel(org_id)
  }
  @Action({ rawError: true })
  public async material({ org_id, teacherEmployeeId, student_id }) {
    return await material(org_id, teacherEmployeeId, student_id)
  }
  @Action({ rawError: true })
  public async courseSign({ org_id, course_id }) {
    return await courseSign(org_id, course_id)
  }
  @Action({ rawError: true })
  public async getEditAudition({ org_id, course_id, types }) {
    return await getEditAudition(org_id, course_id, types)
  }
  @Action({ rawError: true })
  public async getClassSign(data) {
    return await getClassSign(data)
  }
  @Action({ rawError: true })
  public async getCourseSignLists({ org_id, course_id, student_id, types }) {
    return await getCourseSignLists(org_id, course_id, student_id, types)
  }
  @Action({ rawError: true })
  public async studentLevel({ org_id }) {
    return await studentLevel(org_id)
  }
  @Action({ rawError: true })
  public async dashboardStudent({ data_type, instrument_type, campus_id, teacher_id, start_time, end_time }) {
    return await dashboardStudent(data_type, instrument_type, campus_id, teacher_id, start_time, end_time)
  }
  @Action({ rawError: true })
  public async campusDetails({ campus_id }) {
    return await campusDetails(campus_id)
  }
  @Action({ rawError: true })
  public async addCampusClassroom(data) {
    return await addCampusClassroom(data)
  }
  @Action({ rawError: true })
  public async editCampusClassroom(data) {
    return await editCampusClassroom(data)
  }
  @Action({ rawError: true })
  public async deleteCampusClassroom({ id }) {
    return await deleteCampusClassroom(id)
  }
  @Action({ rawError: true })
  public async editCourse(data) {
    return await editCourse(data)
  }
  @Action({ rawError: true })
  public async saleList({ is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await saleList(is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async orderList({ is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await orderList(is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async marketList({ is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await marketList(is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async customerList({ is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await customerList(is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async teachList({ is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await teachList(is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async yearSale({ field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await yearSale(field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async saleDetailList({ field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size }) {
    return await saleDetailList(field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size)
  }
  @Action({ rawError: true })
  public async marketDetailList({ field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size }) {
    return await marketDetailList(field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size)
  }
  @Action({ rawError: true })
  public async customerDetailList({ field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size }) {
    return await customerDetailList(field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size)
  }
  @Action({ rawError: true })
  public async orderDetailList({ field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size }) {
    return await orderDetailList(field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size)
  }
  @Action({ rawError: true })
  public async yearOrder({ field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await yearOrder(field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async yearMarket({ field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await yearMarket(field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async yearTeachData({ field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await yearTeachData(field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async yearCustomer({ field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source }) {
    return await yearCustomer(field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source)
  }
  @Action({ rawError: true })
  public async teachCourseList({ campus_id, teacher_id, instrument_type, course_type_id, course_type, course_level_id, sale_employee_id, start_time, end_time, page, size, is_work }) {
    return await teachCourseList(campus_id, teacher_id, instrument_type, course_type_id, course_type, course_level_id, sale_employee_id, start_time, end_time, page, size, is_work)
  }
  @Action({ rawError: true })
  public async deleteFeedback(data) {
    return await deleteFeedback(data)
  }
}

export const UserModule = getModule(User)
